
import {
  ENVIO_CONTABILIDADE_STATUS_LABELS,
  ENVIO_CONTABILIDADE_STATUS_VARIANTS,
} from "@/modules/envio-contabilidade/utils";

export default {
  name: "EnvioContabilidadeStatusBadge",
  props: {
    status: {
      type: String,
      default: "",
    },
  },
  computed: {
    textLabel() {
      return ENVIO_CONTABILIDADE_STATUS_LABELS[this.status] || this.status || "-";
    },
    variantLabel() {
      return ENVIO_CONTABILIDADE_STATUS_VARIANTS[this.status] || "secondary";
    },
  },
};
